import { Box, CircularProgress, Switch, alpha, styled } from "@mui/material";
import { SwitchProps } from "@mui/material/Switch";
import { memo } from "react";

const CustomSwitch = styled(Switch)(({ theme }) => ({
    margin: -6,
    "& .MuiSwitch-track": {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
    },
    "& .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
    },
    "& .MuiSwitch-switchBase .MuiSwitch-track": {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
    },
    "& .MuiSwitch-switchBase..Mui-checked + .MuiSwitch-track": {
        backgroundColor: alpha(theme.palette.primary.main, 0.5),
    },
}));

export interface LoadingSwitchProps extends SwitchProps {
    checked: boolean;
    loading: boolean;
}

interface IconProps {
    active: boolean;
    loading: boolean;
    disabled: boolean;
}

const Icon = memo(({ active, disabled, loading }: IconProps) => {
    return (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 20,
                height: 20,
                borderRadius: "50%",
                backgroundColor: (theme) => (active && !loading ? theme.palette.primary.main : "#fafafa"),
                boxShadow:
                    "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);",
                opacity: disabled && !loading ? 0.3 : 1,
            }}
        >
            {loading && <CircularProgress size={16} color="primary" thickness={7} />}
        </Box>
    );
});

const MuiLoadingSwitch = ({ checked, loading, disabled, ...props }: LoadingSwitchProps) => {
    return (
        <div onClick={(e) => e.stopPropagation()}>
            <CustomSwitch
                checkedIcon={<Icon loading={loading} active={true} disabled={disabled || false} />}
                icon={<Icon loading={loading} active={false} disabled={disabled || false} />}
                disabled={disabled || loading}
                sx={{
                    placeSelf: "start",
                }}
                checked={checked}
                {...props}
            />
        </div>
    );
};

export default memo(MuiLoadingSwitch);
